module.exports = __webpack_public_path__ + "static/media/bfile-no.9c9de24c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-no.svg
// module id = 167
// module chunks = 0